// extracted by mini-css-extract-plugin
export default {"section":"Contact_section__VrjUR"};